module.exports = __webpack_public_path__ + "static/media/ovn_white.51dbab38.svg";